import {Booking} from "../../../../core/entities/booking/domain/models/booking.model";
import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class BookingUpdatedEvent implements DomainEvent {
  readonly occurredAt = new Date();
  readonly eventType = 'BookingUpdatedEvent';

  constructor(
    public readonly booking: Booking,
    public readonly optimistic = false,
  ) {
  }
}
